module.exports = __webpack_public_path__ + "static/12-b0ab2377915ac18b5da9c4c0df85c377.jpg";